<pre class="json">
  {{ component | json }}
</pre>
